import { Component } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { SortDirection } from '@swimlane/ngx-datatable';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { TipoStatus, TipoStatusLabel } from 'src/app/enums/tipo-status.enum';
import { Bordero } from 'src/app/models/operacionais/importacao-bordero/bordero';
import { BorderoFiltroRequest } from 'src/app/models/operacionais/importacao-bordero/bordero-filtro-request';
import { BorderoListaPaginadaResponse } from 'src/app/models/operacionais/importacao-bordero/bordero-lista-paginada-response';
import { SelectList } from 'src/app/models/select-list';
import { BorderoService } from 'src/app/services/bordero.service';
import { ModalService } from 'src/app/services/shared/modal-service';
import { UtilsService } from 'src/app/utils/utils.service';

@Component({
    selector: 'app-modal-historico-importacao',
    templateUrl: './modal-historico-importacao.component.html',
    styleUrls: ['../../../../../vendor/styles/pages/modal-historico-importacao.scss',
        '../../../../../vendor/libs/ng2-nouislider/ng2-nouislider.scss',
    ],
})
export class ModalHistoricoImportacaoComponent {
    filterNomeDoArquivo = '';
    filterStatus: TipoStatus = null;
    filterStatusList: SelectList[] = [];

    perPage = 8;
    currentPage = 1;
    totalItems = 0;
    sortBy = 'dataImportacao';
    sortDesc = true;
    carregado = false;

    borderos: Bordero[] = [];
    borderosFiltrados: Bordero[] = [];

    modalRef: NgbModalRef;

    constructor(
        public toastrService: ToastrService,
        private spinner: NgxSpinnerService,
        public modalService: ModalService,
        public borderoService: BorderoService,
        public utilsService: UtilsService
    ) {
        this.loadData();

        this.filterStatusList.push(new SelectList(null, 'Todos'));
        this.filterStatusList.push(new SelectList(TipoStatus.BorderoSucesso.toString(), TipoStatusLabel.get(TipoStatus.BorderoSucesso)));
        this.filterStatusList.push(new SelectList(TipoStatus.BorderoErro.toString(), TipoStatusLabel.get(TipoStatus.BorderoErro)));
    }

    loadData() {
        this.buscarborderos();
    }

    get totalPages() {
        return Math.ceil(this.totalItems / this.perPage);
    }

    update() {
        this.buscarborderos();
    }

    filtrar() {
        this.currentPage = 1;
        this.buscarborderos();
    }

    setSort(key: string) {
        if (this.sortBy !== key) {
            this.sortBy = key;
            this.sortDesc = false;
        } else {
            this.sortDesc = !this.sortDesc;
        }

        this.currentPage = 1;
        this.buscarborderos();
    }

    buscarborderos() {
        this.spinner.show();

        const filtro: BorderoFiltroRequest = {
            paginacao: {
                itensPorPagina: parseInt(String(this.perPage), 10),
                paginaAtual: this.currentPage,
                colunaOrdenacao: this.sortBy,
                direcaoOrdenacao: this.sortDesc ? SortDirection.desc : SortDirection.asc,
            },
            nomeDoArquivo: this.filterNomeDoArquivo,
            status: this.filterStatus != null ? Number(this.filterStatus) : null
        };

        this.borderoService.getPaginado(filtro)
            .subscribe((res: BorderoListaPaginadaResponse) => {
                this.borderos = res.data.itens;
                this.borderosFiltrados = res.data.itens;
                this.totalItems = res.data.paginacao.totalItens;
                this.carregado = true;

                this.spinner.hide();
            }, error => {
                if (error && error.errors) {
                    this.toastrService.error(error.errors[0], 'Atenção');
                }
                else {
                    this.toastrService.error('Não foi possível carregar os dados!', 'Atenção', { timeOut: 10000 });
                }

                this.borderos = [];
                this.borderosFiltrados = [];
                this.totalItems = 0;
                this.carregado = true;

                this.spinner.hide();
            });
    }

    download(bordero: Bordero) {
        this.borderoService.download(bordero).subscribe(
            data => {
                this.utilsService.renderDownload(data, bordero.nomeDoArquivo as string);
            }
        );
    }

    public close() {
        this.modalRef.close();
    }

    public dismiss() {
        this.modalRef.dismiss();
    }

    public abrirModalBorderoLinha(bordero: Bordero) {
        this.modalService.abrirModalHistoricoImportacaoLinha(bordero);
    }
}
